import React from "react";

interface IDefaultStore {
    global: any,
    setGlobal: Function
}

const defaultStore: IDefaultStore = {
    global: {},
    setGlobal: (store: {}) => {}
}

export default React.createContext(defaultStore);
